export default __webpack_public_path__ + "static/media/social-events-desktop@2x.5b215fd3.jpg";